import "core-js/modules/es.array.push.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { AccountOwnership, UserType } from 'app/types/User';
import { UserStatus } from 'app/types/UserStatus';
import PageHeader from "../../core/App/PageHeader";
import { LoadingSpinner } from "../../core/components/LoadingSpinner";
import { AccessType, UserRole, useMeQuery, useProductsQuery } from 'legoland-sdk/dist/experimental';
import { useMemo } from 'react';
import { useHistory, useLocation } from 'react-router';
import { Box, Heading } from 'tombac';
import { getNearestPageSize } from "../../contracts/list/Pagination";
import { CreateUserButton } from "../form/CreateUserButton";
import UsersFilter from "./UsersFilter";
import { UsersList } from "./UsersList";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const filterUrlParamsMapping = new Map([['searchValues', 'search'], ['statuses', 'status'], ['productAccessTypes', 'access'], ['accountOwnerships', 'accountOwnership'], ['types', 'type'], ['products', 'product'], ['roles', 'role']]);
const pageUrlParamsMapping = new Map([['index', 'page'], ['size', 'pageSize']]);
const sortByUrlParamsMapping = new Map([['id', 'sortBy'], ['desc', 'desc']]);
function filterValidEnumValues(enumObject, values) {
  const validated = [];
  for (const value of values) {
    if (Object.values(enumObject).includes(value)) {
      validated.push(value);
    }
  }
  return validated;
}
function getUrlForParams(params, location, mapping) {
  const searchParams = new URLSearchParams(location.search);
  for (const [sourceName, urlName] of mapping.entries()) {
    searchParams.delete(urlName);
    const value = params && params[sourceName];
    if (value) {
      if (value instanceof Array) {
        for (const item of value) {
          searchParams.append(urlName, item);
        }
      } else {
        searchParams.set(urlName, value);
      }
    }
  }
  return `${location.pathname}?${searchParams.toString()}`;
}
export const UsersListPage = () => {
  const products = useProductsQuery().data?.products;
  const location = useLocation();
  const history = useHistory();
  const meQuery = useMeQuery();
  const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const filters = {
    searchValues: searchParams.get('search'),
    statuses: filterValidEnumValues(UserStatus, searchParams.getAll('status')),
    accountOwnerships: filterValidEnumValues(AccountOwnership, searchParams.getAll('accountOwnership')),
    types: filterValidEnumValues(UserType, searchParams.getAll('type')),
    productAccessTypes: filterValidEnumValues(AccessType, searchParams.getAll('access')),
    roles: filterValidEnumValues(UserRole, searchParams.getAll('role')),
    products: searchParams.getAll('product').filter(fp => products?.find(p => p.id === fp))
  };
  const parsedPage = Number(searchParams.get('page'));
  const parsedPageSize = Number(searchParams.get('pageSize'));
  const page = {
    index: Number.isNaN(parsedPage) || parsedPage < 1 ? 0 : parsedPage - 1,
    size: Number.isNaN(parsedPageSize) ? 20 : getNearestPageSize(parsedPageSize)
  };
  const sortBy = useMemo(() => searchParams.has('sortBy') ? [{
    id: searchParams.get('sortBy'),
    desc: searchParams.get('desc') === 'true' ? true : false
  }] : [], [searchParams]);
  const handleFiltersChange = filters => {
    history.replace(getUrlForParams(filters, location, filterUrlParamsMapping));
  };
  const handlePageChange = page => {
    history.replace(getUrlForParams({
      ...page,
      index: page.index + 1
    }, location, pageUrlParamsMapping));
  };
  const handleSortByChange = sortBy => {
    history.replace(getUrlForParams(sortBy && sortBy[0], location, sortByUrlParamsMapping));
  };
  const role = meQuery.data?.me?.role;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(PageHeader, {
      transparent: true,
      "data-sentry-element": "PageHeader",
      "data-sentry-source-file": "UsersListPage.tsx",
      "data-sentry-element": "PageHeader",
      children: [/*#__PURE__*/_jsxs(Box, {
        $display: "flex",
        $alignItems: "center",
        $mb: "2sp",
        "data-sentry-element": "Box",
        "data-sentry-source-file": "UsersListPage.tsx",
        "data-sentry-element": "Box",
        children: [/*#__PURE__*/_jsx(Heading, {
          level: 3,
          as: "h1",
          $mb: "0sp",
          "data-sentry-element": "Heading",
          "data-sentry-source-file": "UsersListPage.tsx",
          "data-sentry-element": "Heading",
          children: "Users"
        }), role !== UserRole.Support && /*#__PURE__*/_jsx(CreateUserButton, {
          $ml: "3sp"
        })]
      }), /*#__PURE__*/_jsx(UsersFilter, {
        role: role,
        query: {
          filters,
          page,
          sortBy
        },
        onChange: handleFiltersChange,
        "data-sentry-element": "UsersFilter",
        "data-sentry-source-file": "UsersListPage.tsx",
        "data-sentry-element": "UsersFilter"
      })]
    }), products ? /*#__PURE__*/_jsx(UsersList, {
      filters: filters,
      page: page,
      onPageChange: handlePageChange,
      onSortByChange: handleSortByChange,
      sortBy: sortBy
    }) : /*#__PURE__*/_jsx(LoadingSpinner, {})]
  });
};